module.exports = __webpack_public_path__ + "img/icon_changevolume_color.5746f471.svg";